var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_18876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5009 1.28516C16.3749 1.30267 15.2734 1.61701 14.3077 2.19643C13.342 2.77585 12.5463 3.59983 12.0009 4.58516C11.4556 3.59983 10.6599 2.77585 9.69417 2.19643C8.72848 1.61701 7.62698 1.30267 6.50094 1.28516C4.70588 1.36315 3.01464 2.14841 1.79672 3.46939C0.578794 4.79037 -0.0668157 6.53968 0.000934853 8.33516C0.000934853 15.1102 10.9569 22.9352 11.4229 23.2672L12.0009 23.6762L12.5789 23.2672C13.0449 22.9372 24.0009 15.1102 24.0009 8.33516C24.0687 6.53968 23.4231 4.79037 22.2052 3.46939C20.9872 2.14841 19.296 1.36315 17.5009 1.28516V1.28516ZM12.0009 21.2142C8.74793 18.7842 2.00093 12.8142 2.00093 8.33516C1.93258 7.06987 2.3673 5.82889 3.2103 4.88286C4.0533 3.93683 5.23617 3.36251 6.50094 3.28516C7.7657 3.36251 8.94857 3.93683 9.79157 4.88286C10.6346 5.82889 11.0693 7.06987 11.0009 8.33516H13.0009C12.9326 7.06987 13.3673 5.82889 14.2103 4.88286C15.0533 3.93683 16.2362 3.36251 17.5009 3.28516C18.7657 3.36251 19.9486 3.93683 20.7916 4.88286C21.6346 5.82889 22.0693 7.06987 22.0009 8.33516C22.0009 12.8162 15.2539 18.7842 12.0009 21.2142Z",
    fill: "#253D4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_18876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.367188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.7ff962455198851a38b27faf7ad586e8.svg";
export { ForwardRef as ReactComponent };